document.addEventListener("DOMContentLoaded", function () {
	const accordionItems = document.querySelectorAll(".accordion-item");

	if (!accordionItems.length) {
		return;
	}

	accordionItems.forEach((item) => {
		const button = item.querySelector(".accordion-button");
		const content = item.querySelector(".accordion-content");

		if (!button || !content) {
			return;
		}

		// Set initial ARIA attributes for accessibility
		const isExpanded = content.classList.contains("active");
		button.setAttribute("aria-expanded", isExpanded.toString());

		button.addEventListener("click", function () {
			console.log("matty");
			const wasActive = this.getAttribute("aria-expanded") === "true";

			// Close all other accordion items first
			accordionItems.forEach((otherItem) => {
				console.log("lucas");
				if (otherItem !== item) {
					const otherButton =
						otherItem.querySelector(".accordion-button");
					const otherContent =
						otherItem.querySelector(".accordion-content");

					if (otherButton && otherContent) {
						otherContent.classList.remove("active");
						otherButton.classList.remove("active");
						otherButton.setAttribute("aria-expanded", "false");
					}
				}
			});

			// Toggle the clicked item's state
			if (!wasActive) {
				console.log("click");
				content.classList.add("active");
				this.classList.add("active");
				this.setAttribute("aria-expanded", "true");
			} else {
				content.classList.remove("active");
				this.classList.remove("active");
				this.setAttribute("aria-expanded", "false");
			}
		});
	});
});
